// extracted by mini-css-extract-plugin
export default {"active_wave":"WaveContainer_active_wave__TSlQn","wave":"WaveContainer_wave__ev-go"};